import { Flex } from "@chakra-ui/react";

export function Footer() {

    const year = new Date().getFullYear();

    return <Flex bgColor="rgba(11, 11, 13, 1)" py="26px" color="rgba(103, 108, 124, 1)" justifyContent="center" alignItems="center">
        Gambly {year}. All Rights Reserved
    </Flex>
}